import { withInstall } from '@tav-ui/utils/with-install'
import StrengthMeter from './src/strength-meter.vue'
const TaStrengthMeter = withInstall(StrengthMeter)
export * from './src/types'
export { TaStrengthMeter }
export default TaStrengthMeter
